import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { ContentBlock } from "@/components/wpl/content-block/src";
import ThreeAlternatingImageText, {
    PatternThreeAlternatingImageTextProps
} from "@/patterns/three-alternating-image-text/src/three-alternating-image-text";

const JiraProductDiscoverySideBySideSectionStyle = css({
    "paddingBlockStart": "96px",
    "paddingBlockEnd": "0px",
    [media.above.md]: {
        paddingBlockStart: "64px",
        paddingBlockEnd: "64px"
    },
    ".sideBySideHeader": {
        paddingBlockStart: "96px",
        paddingBlockEnd: "32px",
        paddingInlineStart: "16px",
        paddingInlineEnd: "16px",
        [media.above.md]: {
            paddingBlockStart: "64px"
        }
    },
    "backgroundImage":
        "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg.webp), linear-gradient(180deg, #172B4D 0%, #172B4D 100%)",
    "backgroundPosition": "top left , 0 0",
    "backgroundRepeat": "no-repeat , no-repeat",
    "backgroundSize": "260px , auto",
    [media.above.sm]: {
        backgroundSize: "280px , auto"
    },
    [media.above.md]: {
        backgroundSize: "300px , auto"
    },
    [media.above.lg]: {
        backgroundImage:
            "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg.webp), url(https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg2.webp), url(https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg3.webp), linear-gradient(180deg, #172B4D 0%, #172B4D 100%)",
        backgroundPosition: "top left , top 70% right , bottom 50px left , 0 0",
        backgroundRepeat: "no-repeat , no-repeat , no-repeat , no-repeat",
        backgroundSize: "300px , 100px , 100px , auto"
    },
    ".text-section": {
        "h1, h2, h3, h4, h5, p, .contentBlock-eyebrow, .contentBlock-body": {
            color: "#FFFFFF !important"
        }
    }
});

export interface SideBySideSectionProps {
    headerHeaderText?: string;
    headerBodyText?: string;
    alternatingTextAndImageProps: PatternThreeAlternatingImageTextProps;
}

const SideBySideSection = ({
    headerHeaderText,
    headerBodyText,
    alternatingTextAndImageProps
}: SideBySideSectionProps) => {
    return (
        <div css={JiraProductDiscoverySideBySideSectionStyle}>
            <ContentBlock
                headerText={headerHeaderText}
                bodyText={headerBodyText}
                className="sideBySideHeader"
                headerType="h2"
                isCentered={true}
            />
            <ThreeAlternatingImageText {...alternatingTextAndImageProps} />
        </div>
    );
};

export default SideBySideSection;
